webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(103)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(225),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(231);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: {
		loginForm: {
			username: '',
			password: ''
		},
		// 登录状态
		loginStatus: false
	},
	getter: {
		userLoginStatus: function userLoginStatus(state) {
			console.log('入参zzzzz：', state.loginStatus);
			return state.loginStatus;
		}
	},
	mutations: {
		SET_LOGINSTATUS: function SET_LOGINSTATUS(state, newLoginStatus) {
			state.loginStatus = newLoginStatus;
			console.log('入参：', state.loginStatus);
		}
	},
	actions: {
		setloginStatus: function setloginStatus(_ref, newLoginStatus) {
			var dispatch = _ref.dispatch,
			    commit = _ref.commit,
			    state = _ref.state;

			commit('SET_LOGINSTATUS', newLoginStatus);
		}
	}
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);


var url = {
	apiUrl: "/ccp-web/api", //接口路径
	ctxPath: "/dist", //node服务dist目录
	//staticPath:config.dev.staticPath,       //开发环境静态资源路径  
	staticPath:  true ? __WEBPACK_IMPORTED_MODULE_0__config___default.a.build.staticPath : config.dev.staticPath
};

var api = {
	'home': url.staticPath + 'dataJson/home.json',
	'classify': url.staticPath + 'dataJson/classify.json',
	'login': url.staticPath + 'dataJson/login.json',
	'captchas': '/v1/captchas'
};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(99)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(221),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"'
}


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(102)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(224),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(98)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(220),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */,
/* 80 */
/***/ (function(module, exports) {

(function (doc, win) {
    var docEl = doc.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function recalc() {
        var clientWidth = docEl.clientWidth;
        if (!clientWidth) return;
        docEl.style.fontSize = 20 * (clientWidth / 375) + 'px';
    };
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_navBar__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_navBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__view_navBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_home__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__view_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_classify__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_classify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__view_classify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_register__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__view_register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_login__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__view_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_shopping__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_shopping___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__view_shopping__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_personal__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_personal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__view_personal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__view_dragonDetail__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__view_dragonDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__view_dragonDetail__);



// 底部导航

// 首页

// 分类

// 用户注册

// 用户登录

// 购物车

// 个人中心

// 商品详细页


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{ path: '/home', component: __WEBPACK_IMPORTED_MODULE_3__view_home___default.a }, { path: '/dragonDetail', component: __WEBPACK_IMPORTED_MODULE_9__view_dragonDetail___default.a }, { path: '/classify', component: __WEBPACK_IMPORTED_MODULE_4__view_classify___default.a }, { path: '/shopping', component: __WEBPACK_IMPORTED_MODULE_7__view_shopping___default.a }, { path: '/personal', component: __WEBPACK_IMPORTED_MODULE_8__view_personal___default.a }, { path: '/register', component: __WEBPACK_IMPORTED_MODULE_5__view_register___default.a }, { path: '/login', component: __WEBPACK_IMPORTED_MODULE_6__view_login___default.a }, { path: '/', redirect: 'home' }]
}));

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(101)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(223),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__(232)
var prodEnv = __webpack_require__(43)

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// see http://vuejs-templates.github.io/webpack for documentation.
var path = __webpack_require__(198)

module.exports = {
  build: {
    env: __webpack_require__(43),
    index: path.resolve(__dirname, '../dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: '',
    assetsPublicPath: './',
    staticPath:'./',  //相对路径
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: __webpack_require__.i({"NODE_ENV":"production"}).npm_config_report
  },
  dev: {
    env: __webpack_require__(85),
    port: 8081,
    autoOpenBrowser: true,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    staticPath:'/static/',   //以/开头绝对路径
    proxyTable: {
        '/v1': {
            target: 'http://images.cangdu.org/',
            changeOrigin : true,
            pathRewrite: {
              '^/v1': '/v1'
            }
        }
    },
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 87 */,
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_navBar__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_navBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__view_navBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_api__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 底部导航


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			value: '',
			lists: ''
		};
	},

	components: {
		NavBar: __WEBPACK_IMPORTED_MODULE_0__view_navBar___default.a
	},
	mounted: function mounted() {
		this.getData();
	},
	methods: {
		goBack: function goBack() {
			this.$router.go(-1);
		},
		getData: function getData() {
			var _this = this;

			this.$http.get(__WEBPACK_IMPORTED_MODULE_1__global_api__["a" /* api */].classify).then(function (response) {
				_this.lists = response.data.data;
			});
		}
	}
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},

	methods: {
		goBack: function goBack() {
			this.$router.go(-1);
		}
	}
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_1_jpg__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_img_1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_2_jpg__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_3_jpg__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_3_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_3_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_6_jpg__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_6_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_6_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_7_jpg__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_7_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_7_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_8_jpg__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_8_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_8_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_9_jpg__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_9_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_9_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_10_jpg__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_10_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_10_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_11_jpg__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_11_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_11_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_12_jpg__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_12_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_12_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_13_jpg__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_13_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_13_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__view_navBar__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__view_navBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__view_navBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__view_dragonDetail__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__view_dragonDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__view_dragonDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__view_login__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__view_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__view_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__global_api__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












// import img14 from '../assets/img/14.jpg'
// import img15 from '../assets/img/15.jpg'
// import img16 from '../assets/img/16.jpg'
// import img17 from '../assets/img/17.jpg'
// import img18 from '../assets/img/18.jpg'
// import img19 from '../assets/img/19.jpg'
// 底部导航





/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			value: '',
			// 图片轮播
			imgs: [__WEBPACK_IMPORTED_MODULE_0__assets_img_1_jpg___default.a, __WEBPACK_IMPORTED_MODULE_1__assets_img_2_jpg___default.a, __WEBPACK_IMPORTED_MODULE_2__assets_img_3_jpg___default.a],
			// 8大热销茶叶品类
			list: [__WEBPACK_IMPORTED_MODULE_3__assets_img_6_jpg___default.a, __WEBPACK_IMPORTED_MODULE_4__assets_img_7_jpg___default.a, __WEBPACK_IMPORTED_MODULE_5__assets_img_8_jpg___default.a, __WEBPACK_IMPORTED_MODULE_6__assets_img_9_jpg___default.a, __WEBPACK_IMPORTED_MODULE_7__assets_img_10_jpg___default.a, __WEBPACK_IMPORTED_MODULE_8__assets_img_11_jpg___default.a, __WEBPACK_IMPORTED_MODULE_9__assets_img_12_jpg___default.a, __WEBPACK_IMPORTED_MODULE_10__assets_img_13_jpg___default.a],
			// 人气新品
			// Img:[img14,img15,img16,img17,img18,img19],
			loading: false,
			products: ''
		};
	},

	components: {
		NavBar: __WEBPACK_IMPORTED_MODULE_11__view_navBar___default.a
	},
	mounted: function mounted() {
		this.getData();
	},
	methods: {
		getData: function getData() {
			var _this = this;

			console.log("aaa");
			this.$http.get(__WEBPACK_IMPORTED_MODULE_14__global_api__["a" /* api */].home).then(function (response) {
				_this.products = response.data;
			});
		},
		handleSelected: function handleSelected(index) {
			this.$router.push({ path: '/dragonDetail', component: __WEBPACK_IMPORTED_MODULE_12__view_dragonDetail___default.a });
		}
	}
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_home__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__view_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 首页




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			loginForm: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.loginForm,
			form: ''
			// loginStatus:store.state.loginStatus
			// captchaCodeImg:''
		};
	},

	mounted: function mounted() {
		this.getData();
		// this.getCaptchas();
	},
	methods: {
		getData: function getData() {
			var _this = this;

			this.$http.get(__WEBPACK_IMPORTED_MODULE_2__global_api__["a" /* api */].login).then(function (response) {
				console.log("登录页面response的值", response);
				_this.form = response.data;
			});
		},
		loginSubmit: function loginSubmit() {
			console.log("this.loginForm.username：", this.loginForm.username);
			console.log("this.loginForm.password：", this.loginForm.password);
			var flag = 0;
			for (var i = 0; i < this.form.length; i++) {
				if (this.form[i].username === this.loginForm.username && this.form[i].password == this.loginForm.password) {
					flag = 1;
					break;
				}
			}
			if (flag === 0) {
				__WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"].alert("用户名或密码不正确", "提示");
				this.loginForm.username = '';
				this.loginForm.password = '';
			} else {
				this.$router.push({ path: '/', component: __WEBPACK_IMPORTED_MODULE_0__view_home___default.a });
				// this.loginStatus=true;
				__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('setloginStatus', true);
				// console.log("login页面的loginStatus值",this.loginStatus);
			}
		}
		// getCaptchas:function(){
		// 	this.$http.get(api.captchas).then((response) => {
		// 		console.log("图片验证码",response);
		// 	},() => {
		// 		console.log("请求失败");
		// 	})
		// }
	}
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			selected: '',
			fixed: true
		};
	}
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_navBar__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_navBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__view_navBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_login__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__view_login__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 底部导航



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			loginForm: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.loginForm
		};
	},

	components: {
		NavBar: __WEBPACK_IMPORTED_MODULE_0__view_navBar___default.a
	},
	computed: {
		loginStatus: function loginStatus() {
			return this.$store.state.loginStatus;
		}
	},
	mounted: function mounted() {
		if (!this.loginStatus) {
			this.$router.push({ path: '/login', component: __WEBPACK_IMPORTED_MODULE_2__view_login___default.a });
		}
	},
	methods: {
		goBack: function goBack() {
			this.$router.go(-1);
		}
	}
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_api__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			rulesForm: {
				username: '',
				email: '',
				password: '',
				dbpassword: '',
				phone: ''
			},
			form: '',
			popupVisible: false
		};
	},

	mounted: function mounted() {
		this.getData();
	},
	methods: {
		goBack: function goBack() {
			this.$router.go(-1);
		},
		getData: function getData() {
			this.$http.get(__WEBPACK_IMPORTED_MODULE_1__global_api__["a" /* api */].login).then(function (response) {
				console.log("response的值", response);
				this.form = response.data;
			});
		},
		registerSubmit: function registerSubmit() {
			var value = true;
			// 判断用户名是否为空或已存在
			var flag = 0;
			for (var i = 0; i < this.form.length; i++) {
				if (this.rulesForm.username === this.form[i].username) {
					flag = 1;
					break;
				}
			}
			console.log("flag的值", flag);
			if (!this.rulesForm.username) {
				__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"].alert("用户名不能为空", "提示");
				value = false;
			}
			if (flag === 1) {
				__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"].alert("用户名已存在", "提示");
				value = false;
			}
			// 判断邮箱是否符合格式要求
			// if(!this.rulesForm.email){
			// 	MessageBox.alert("邮箱不能为空", "提示");
			// }
			// var reg=/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
			// if(!reg.test(this.rulesForm.email)){
			// 	MessageBox.alert("邮箱必须包含@", "提示");
			// }

			// 判断电话是否为11位数字
			if (!this.rulesForm.phone) {
				__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"].alert("电话号码不能为空", "提示");
				value = false;
			}
			var reg = /^[0-9]{11}$/;
			if (!reg.test(this.rulesForm.phone)) {
				__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"].alert("电话号码必须为11位数字", "提示");
				value = false;
			}
			// 判断密码是否为空
			if (!this.rulesForm.password) {
				__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"].alert("密码不能为空", "提示");
				value = false;
			}
			// 判断两次输入密码是否一致
			if (this.rulesForm.password !== '') {
				if (!this.rulesForm.dbpassword) {
					__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"].alert("请再次输入密码", "提示");
					value = false;
				} else if (this.rulesForm.password === this.rulesForm.dbpassword) {
					console.log("两次密码一致");
				} else {
					__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"].alert("两次密码不一致", "提示");
					value = false;
					this.rulesForm.password = '';
					this.rulesForm.dbpassword = '';
				}
			}
			if (value === true) {
				__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"].alert("注册成功", "提示");
			}
		}
	}
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_navBar__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_navBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__view_navBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_login__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__view_login__);
//
//
//
//
//
//
//
//
//
//
//

// 底部导航


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},

	components: {
		NavBar: __WEBPACK_IMPORTED_MODULE_0__view_navBar___default.a
	},
	computed: {
		loginStatus: function loginStatus() {
			return this.$store.state.loginStatus;
		}
	},
	mounted: function mounted() {
		// 未登录状态重定向到登录页面
		if (!this.loginStatus) {
			this.$router.push({ path: '/login', component: __WEBPACK_IMPORTED_MODULE_1__view_login___default.a });
		}
		console.log('tai', this.loginStatus);
		console.log(0);
	},
	methods: {
		goBack: function goBack() {
			this.$router.go(-1);
		}
	}
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_style_css__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rem_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rem_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rem_js__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








// 移动端高清屏适配方案


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_mint_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/1.f95f79e.jpg";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/10.0b28986.jpg";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/11.dd21f4a.jpg";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/12.998fc1e.jpg";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/13.db42f26.jpg";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/2.fd6c8ce.jpg";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/3.b83fab5.jpg";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/4.dc3259b.png";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/5.d22a3de.png";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/6.82899c8.jpg";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/7.933e61e.jpg";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/8.503f48d.jpg";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/9.8ead7e3.jpg";

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 215 */,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(100)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(222),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(104)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(226),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(227),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(106)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(228),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('header', [_c('div', {
    staticClass: "title"
  }, [_vm._v("醉品商城")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('mt-search', {
    attrs: {
      "cancel-text": "取消",
      "placeholder": "搜索您想要的产品"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', {
    staticClass: "swipe"
  }, [_c('mt-swipe', {
    attrs: {
      "auto": 4000
    }
  }, _vm._l((_vm.imgs), function(img) {
    return _c('mt-swipe-item', [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (img),
        expression: "img"
      }]
    })])
  }))], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('section', {
    staticClass: "part3"
  }, [_c('h3', [_vm._v("8大热销茶叶品类")]), _vm._v(" "), _c('p', [_vm._v("总有你想不到的低价")]), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "list-img"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item),
        expression: "item"
      }]
    })])
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "part4"
  }, [_c('div', {
    staticClass: "part4-content"
  }, [_c('div', {
    staticClass: "newProducts"
  }, [_c('h3', [_vm._v(_vm._s(_vm.products.title))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.products.note))]), _vm._v(" "), _vm._l((_vm.products.data), function(product, index) {
    return _c('div', {
      staticClass: "product",
      on: {
        "click": function($event) {
          _vm.handleSelected(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": product.img
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "product-p1"
    }, [_vm._v(_vm._s(product.bigContent))]), _vm._v(" "), _c('p', {
      staticClass: "product-p2"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(product.smallContent)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "money"
    }, [_c('i', {
      staticClass: "fa fa-jpy",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(product.price.toFixed(2)))])])])
  })], 2)])]), _vm._v(" "), _c('NavBar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "part1"
  }, [_c('div', {
    staticClass: "text-content"
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o check-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("全场商品90天保价")])]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o check-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("30天无忧退换货")])]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o check-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("满59元免运费")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "left"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "part2"
  }, [_c('div', {
    staticClass: "part2-content"
  }, [_c('div', {
    staticClass: "part2-img"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": __webpack_require__(208)
    }
  })]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": __webpack_require__(209)
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "left"
    }
  })])])])
}]}

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('mt-header', {
    attrs: {
      "title": "账户登录"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    },
    slot: "left"
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/register"
    },
    slot: "right"
  }, [_c('mt-button', [_vm._v("注册")])], 1)], 1), _vm._v(" "), _c('form', {
    staticClass: "loginForm",
    attrs: {
      "model": _vm.loginForm
    }
  }, [_c('section', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.username),
      expression: "loginForm.username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "用户名"
    },
    domProps: {
      "value": (_vm.loginForm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginForm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.password),
      expression: "loginForm.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.loginForm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginForm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('mt-button', {
    on: {
      "click": _vm.loginSubmit
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "test"
  }, [_c('p', [_vm._v("测试：")]), _vm._v(" "), _c('p', [_vm._v("用户名/密码:2014874236/123456")]), _vm._v(" "), _c('p', [_vm._v("用户名/密码:2014874239/123456")]), _vm._v(" "), _c('p', [_vm._v("用户名/密码:2014874207/654321")])])
}]}

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify"
  }, [_c('mt-header', {
    attrs: {
      "fixed": "",
      "title": "全部产品分类"
    }
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    },
    on: {
      "click": _vm.goBack
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('mt-search', {
    attrs: {
      "cancel-text": "取消",
      "placeholder": "搜索您想要的产品"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.lists), function(list) {
    return _c('section', {
      staticClass: "tea"
    }, [_c('h3', [_vm._v(_vm._s(list.title))]), _vm._v(" "), _c('div', [_c('ul', [_vm._l((list.items), function(item) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": ""
        }
      }, [_c('p', [_c('img', {
        attrs: {
          "src": item.img
        }
      })]), _vm._v(" "), _c('p', {
        staticClass: "text"
      }, [_vm._v(_vm._s(item.text))])])], 1)
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })], 2)])])
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('NavBar')], 2)
},staticRenderFns: []}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dragonDetail"
  }, [_c('mt-header', {
    attrs: {
      "title": "顶峰 开化龙顶 2017明前茶 绿茶  50g 黄罐单罐"
    }
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    },
    on: {
      "click": _vm.goBack
    },
    slot: "left"
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navBar"
  }, [_c('mt-tabbar', {
    staticClass: "nav",
    attrs: {
      "fixed": "fixed"
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-item', {
    attrs: {
      "id": "home"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("首页")])])], 1), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "classify"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/classify"
    }
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-th-large",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("分类")])])], 1), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "cart"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/shopping"
    }
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("购物车")])])], 1), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "user"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/personal"
    }
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-user-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("我的")])])], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "personal"
  }, [_c('mt-header', {
    attrs: {
      "title": "个人中心"
    }
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    },
    on: {
      "click": _vm.goBack
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "personalInfo"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "username"
  }, [_c('p', [_vm._v(_vm._s(_vm.loginForm.username))]), _vm._v(" "), _c('p', [_vm._v("茶人-V0 您已累计消费0元")])]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('mt-button', [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\t\t签到得积分\n\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "left"
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "myOrder"
  }, [_c('div', {
    staticClass: "order"
  }, [_c('mt-button', {
    staticClass: "btn"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("我的订单")]), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "otherInfo"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('mt-button', {
    staticClass: "btn"
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("地址管理")]), _vm._v(" "), _vm._m(4)], 1), _vm._v(" "), _c('div', {
    staticClass: "password"
  }, [_c('mt-button', {
    staticClass: "btn"
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("修改密码")]), _vm._v(" "), _vm._m(5)], 1), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_c('mt-button', {
    staticClass: "btn"
  }, [_c('i', {
    staticClass: "fa fa-mobile",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("绑定手机")]), _vm._v(" "), _vm._m(6)], 1), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [_c('mt-button', {
    staticClass: "btn"
  }, [_c('i', {
    staticClass: "fa fa-sign-in",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("退出登录")]), _vm._v(" "), _vm._m(7)], 1)]), _vm._v(" "), _c('NavBar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(214)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accountInfo"
  }, [_c('ul', [_c('li', [_c('p', [_vm._v("0")]), _vm._v(" "), _c('p', [_vm._v("账户余额")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("0")]), _vm._v(" "), _c('p', [_vm._v("积分余额")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("0")]), _vm._v(" "), _c('p', [_vm._v("红包个数")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "left"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "moreOrder"
  }, [_vm._v("\n\t\t\t\t查看全部订单\n\t\t\t\t"), _c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderInfo"
  }, [_c('div', {
    staticClass: "wait"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("待付款")])]), _vm._v(" "), _c('div', {
    staticClass: "wait"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("待发货")])]), _vm._v(" "), _c('div', {
    staticClass: "wait"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("待收货")])]), _vm._v(" "), _c('div', {
    staticClass: "wait"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("待评价")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "left"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_c('mt-header', {
    attrs: {
      "title": "用户注册"
    }
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    },
    on: {
      "click": _vm.goBack
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "registerContent"
  }, [_c('form', {
    ref: "rulesForm",
    attrs: {
      "model": _vm.rulesForm
    }
  }, [_c('section', [_c('div', [_c('label', {
    attrs: {
      "id": "username"
    }
  }, [_vm._v("用户名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rulesForm.username),
      expression: "rulesForm.username"
    }],
    attrs: {
      "type": "text",
      "id": "username",
      "placeholder": "请输入用户名"
    },
    domProps: {
      "value": (_vm.rulesForm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rulesForm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('div', [_c('label', {
    attrs: {
      "id": "phone"
    }
  }, [_vm._v("电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rulesForm.phone),
      expression: "rulesForm.phone"
    }],
    attrs: {
      "type": "text",
      "id": "phone",
      "placeholder": "请输入电话号码"
    },
    domProps: {
      "value": (_vm.rulesForm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rulesForm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rulesForm.verification),
      expression: "rulesForm.verification"
    }],
    attrs: {
      "type": "text",
      "id": "verification",
      "placeholder": "4位数字"
    },
    domProps: {
      "value": (_vm.rulesForm.verification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rulesForm.verification = $event.target.value
      }
    }
  }), _vm._v(" "), _c('mt-button', {
    staticClass: "codeBtn",
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("获取验证码")])], 1)]), _vm._v(" "), _c('section', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rulesForm.password),
      expression: "rulesForm.password"
    }],
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.rulesForm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rulesForm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rulesForm.dbpassword),
      expression: "rulesForm.dbpassword"
    }],
    attrs: {
      "type": "password",
      "id": "dbpassword",
      "placeholder": "请重复输入密码"
    },
    domProps: {
      "value": (_vm.rulesForm.dbpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rulesForm.dbpassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('mt-button', {
    staticClass: "btn",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.registerSubmit
    }
  }, [_vm._v("注册")])], 1)])]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n            点击 立即注册 即表示您同意醉品"), _c('span', [_vm._v("用户协议")]), _vm._v("和"), _c('span', [_vm._v("隐私协议")])])
}]}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopping"
  }, [_c('mt-header', {
    attrs: {
      "title": "购物车"
    }
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    },
    on: {
      "click": _vm.goBack
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('NavBar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "emptyShopping"
  }, [_c('p', [_vm._v("你的购物车没有任何商品")])])
}]}

/***/ }),
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[97]);


// WEBPACK FOOTER //
// js/app.0cb40e39034bfd50fffa.js